import { ChangeEvent, ReactElement } from "react";
import { TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";

interface IProps {
  filter: string;
  setFilter: (filter: string) => void;
}

const Filter = ({ filter, setFilter }: IProps): ReactElement => {

  const onchangeFilter = (event: ChangeEvent<HTMLInputElement>) => setFilter(event.target.value.toLowerCase());

  return (
    <TextField
      variant="outlined"
      size="small"
      placeholder="Filter"
      value={filter}
      onChange={onchangeFilter}
      fullWidth={true}
      slotProps={{
        input: {
          startAdornment:
          <InputAdornment position="start">
            <SearchIcon/>
          </InputAdornment>
      }}}
    />
  );
};

export default Filter;
